import { LOCALE_ID, ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideState, provideStore } from '@ngrx/store';
import { provideRouterStore } from '@ngrx/router-store';
import { provideEffects } from '@ngrx/effects';
import { environment } from '../environments/environment';
import { ProvideDictionaryNgrx } from '@teamfoster/sdk/dictionary-ngrx';
import { ProvideIcons } from '@teamfoster/sdk/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { reducers, CustomSerializer, appEffects, metaReducers } from './store';

// not used in production
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { CookieConfig, ProvideCookiesNgrx } from '@teamfoster/sdk/cookie-ngrx';
import { LanguageInterceptor, ProvideLanguageNgrx } from '@teamfoster/sdk/language-ngrx';
import { DynamicFormConfig, ProvideDynamicForms } from '@teamfoster/dynamic-forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ImageSharpConfig, ProvideImageProcessor } from '@teamfoster/sdk/image';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';

import * as fromLandingPages from './landing-page/store';

const dynamicFormConfig: DynamicFormConfig = {
  genericInputErrorMessage: 'TODO: genericInputErrorMessage',
  genericServerErrorMessage: 'TODO: genericServerErrorMessage',
};

const cookieConfig: CookieConfig = {
  analyticsCode: 'G-74544R797R',
  strippedContentPlaceholder: 'Deze inhoud wordt niet getoond omdat je geen marketing cookies hebt geaccepteerd',
  buttonSettings: 'Instellingen',
  buttonAcceptAll: 'Accept all',
  buttonClose: 'Sluiten',
  strippedContentButton: 'Cookie-instellingen wijzigen',
  types: {
    analytical: true,
    functional: true,
    marketing: true,
  },
  showSettings: true,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'emptyOnly',
      }),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'disabled' })
    ),
    provideAnimations(),
    ProvideDynamicForms(dynamicFormConfig),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([LanguageInterceptor])),
    provideStore(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    provideState(fromLandingPages.featureKey, fromLandingPages.reducers),
    provideEffects(...appEffects, ...fromLandingPages.effects),
    provideRouterStore({ serializer: CustomSerializer }),
    provideStoreDevtools({ maxAge: 25, logOnly: environment.production }),
    ProvideIcons({ spritesheetUrl: 'assets/dist/svg/symbol/svg/sprite.symbol.svg' }),
    ProvideDictionaryNgrx({}),
    ProvideLanguageNgrx({ defaultLanguage: 'en-GB' }),
    ProvideCookiesNgrx(cookieConfig),
    ProvideImageProcessor(ImageSharpConfig, {}),
    { provide: LOCALE_ID, useValue: 'nl' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', floatLabel: 'always' } },
  ],
};
